<template>
  <v-card>
    <v-data-table id="employeesDataTable" :headers="this.headers" :items="this.parsedTableData" :item-class="rowBackground" item-key="mocoUserID"
      disable-pagination hide-default-footer show-expand :expanded.sync="expandedRows">

      <template v-slot:item.data-table-expand="{ item: user }">
        <td @click="toggleExpand(user)" class="pa-0 pl-1">
          <v-btn icon>
            <v-icon>{{ expandedRows.includes(user) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-btn>
        </td>
      </template>
      
      <template v-slot:item.fullname="{ item: user }">
        <td @click="toggleExpand(user)" class="pl-1">
          <v-avatar class="my-2 mr-2" size="40">
            <img alt="Avatar" :style="user.isStillEmployed ? '' : 'opacity: 0.5;'"
              :src="user.avatar_url ? user.avatar_url : require('../../assets/avatar_placeholder.png')">
          </v-avatar>
          <label :style="user.isStillEmployed ? '' : 'opacity: 0.5;'">
            {{ user.fullname.firstname + ' ' + user.fullname.lastname }}
          </label>
        </td>
      </template>

      <template v-slot:item.stdSaldo="{ item: user }">
        <td @click="toggleExpand(user)">
          {{ user.stdSaldo }}
        </td>
      </template>

      <template v-slot:item.gzk="{ item: user }">
        <td @click="toggleExpand(user)">
          {{ user.gzk }}
        </td>
      </template>

      <template v-slot:item.urlaub="{ item: user }">
        <td @click="toggleExpand(user)">
          {{ precisionRound(user.urlaub) }}
        </td>
      </template>

      <template v-slot:item.status="{ item: user }">
        <v-btn id="goToMonatsabschluss" width="100%" class="text-overline" 
          :to="getMonatsabschlussRoute(user)" :disabled="gotoMonatsabschlussEnabled(user) != true"
          :color="getMonatsabschlussStatusColor(user.status)" outlined elevation="0" target="_blank">
          <strong class="ma-0 pa-0">{{ user.status }}</strong>
        </v-btn>
      </template>

      <template v-slot:item.impersonate="{ item: user }">
        <v-btn v-if="$store.getters.staticUserData.user.id != user.id" id="impersonateUser" width="100%" class="text-overline" 
          :to="impersonate(user)" :disabled="impersionationEnabled(user) != true"
          outlined elevation="0" target="_blank">
          <v-icon>mdi-account-arrow-right</v-icon>
        </v-btn>
      </template>

      <!-- expanded item -->
      <template v-slot:expanded-item="{ headers, item: user }">
        <td id="employeeExtraMasterData" :colspan="headers.length">
          <v-card flat class="my-3">

            <v-row no-gutters>
              <v-col class="mx-5">
                <v-row no-gutters>
                  <v-col cols="6">
                    <div class="text-overline" style="font-size: 13px !important;"><b>Vorname </b></div>
                  </v-col>

                  <v-col class="custom-vertical-center">
                    <div v-if="user.fullname.firstname">{{ user.fullname.firstname }}</div>
                    <div v-else>-</div>
                  </v-col>
                </v-row>

                <v-divider class="my-1"></v-divider>

                <v-row no-gutters>
                  <v-col cols="6">
                    <div class="text-overline" style="font-size: 13px !important;"><b>Nachname </b></div>
                  </v-col>

                  <v-col class="custom-vertical-center">
                    <div v-if="user.fullname.lastname" style="font-size: 13px !important;">{{
                      user.fullname.lastname }}</div>
                    <div v-else>-</div>
                  </v-col>
                </v-row>

                <v-divider class="my-1"></v-divider>

                <v-row no-gutters>
                  <v-col cols="6">
                    <div class="text-overline" style="font-size: 13px !important;"><b>Team </b></div>
                  </v-col>
                  <v-col class="custom-vertical-center">
                    <div v-if="user.team">{{ user.team }}</div>
                    <div v-else>-</div>
                  </v-col>
                </v-row>

                <v-divider class="my-1"></v-divider>

                <v-row no-gutters>
                  <v-col cols="6">
                    <div class="text-overline" style="font-size: 13px !important;"><b>Personalnummer </b></div>
                  </v-col>
                  <v-col class="custom-vertical-center">
                    <div v-if="user.personnelNumber">{{ user.personnelNumber }}</div>
                    <div v-else>-</div>
                  </v-col>
                </v-row>

                <v-divider class="my-1"></v-divider>

                <v-row no-gutters>
                  <v-col cols="6">
                    <div class="text-overline" style="font-size: 13px !important;"><b>Adresse </b></div>
                  </v-col>
                  <v-col class="custom-vertical-center">
                    <div v-if="user.address">{{ user.address }}</div>
                    <div v-else>-</div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col class="mx-5">
                <v-row no-gutters>
                  <v-col cols="7">
                    <div class="text-overline" style="font-size: 13px !important;"><b>Eintrittsdatum</b></div>
                  </v-col>

                  <v-col class="custom-vertical-center">
                    <div v-if="user.employedSince">{{ formatDate(user.employedSince) }}&nbsp; ({{ yearsSince(user.employedSince) }} Jahre)</div>
                    <div v-else>-</div>
                  </v-col>
                </v-row>

                <v-divider class="my-1"></v-divider>

                <v-row no-gutters :style="user.employedUntil ? 'color:red' : ''">
                  <v-col cols="7">
                    <div class="text-overline" style="font-size: 13px !important;"><b>Ende Dienstverhältnis</b></div>
                  </v-col>

                  <v-col class="custom-vertical-center">
                    <div v-if="user.employedUntil" style="font-size: 13px !important;">{{ formatDate(user.employedUntil) }}</div>
                    <div v-else>-</div>
                  </v-col>
                </v-row>

                <v-divider class="my-1"></v-divider>

                <v-row no-gutters>
                  <v-col cols="7">
                    <div class="text-overline" style="font-size: 13px !important;"><b>Geburtstag</b></div>
                  </v-col>

                  <v-col class="custom-vertical-center">
                    <div v-if="user.birthday" style="font-size: 13px !important;">{{ formatDate(user.birthday) }}&nbsp; ({{ yearsSince(user.birthday) }} Jahre)</div>
                    <div v-else>-</div>
                  </v-col>
                </v-row>

                <v-divider class="my-1"></v-divider>

                <v-row no-gutters>
                  <v-col cols="7">
                    <div class="text-overline" style="font-size: 13px !important;"><b>Überstundenpauschale </b></div>
                  </v-col>

                  <v-col class="custom-vertical-center">
                    <div v-if="user.overTimeFlat != undefined">{{ user.overTimeFlat }} h</div>
                    <div v-else>-</div>
                  </v-col>
                </v-row>

                <v-divider class="my-1"></v-divider>

                <v-row no-gutters>
                  <v-col cols="7">
                    <div class="text-overline" style="font-size: 13px !important;"><b>Monatliche GZK Korrektur </b></div>
                  </v-col>

                  <v-col class="custom-vertical-center">
                    <div v-if="user.monthlyFlexTimeCorrection != undefined">{{ user.monthlyFlexTimeCorrection }} h</div>
                    <div v-else>-</div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col v-if="$route.name == global.ROUTES.hr.employees.name"
                cols="auto" class="align-center mb-12">
                <UpdateEmployee :enabled="userUpdateEnabled && user.isStillEmployed" :employeeToUpdate="user"> </UpdateEmployee>
              </v-col>
            </v-row>

            <v-row no-gutters class="mt-8 mx-5">
              <v-btn id="kpiCalculation" color="#c00000" class="white--text"
                :loading="KPIs.loading && KPIs.values[user.id] == undefined"
                :disabled="KPIs.values[user.id] != undefined"
                @click="startCalculation(user)">
                KPIs berechnen
              </v-btn>
            </v-row>

            <v-row>
              <v-col v-for="KPI in KPIs.values[user.id]" :key="KPI.title" md="6" lg="4" xl="3" class="pt-3 pb-0">
                <v-row no-gutters>
                  <v-col cols="6">
                    <div class="" style="font-size: 13px !important;"><b>{{ KPI.title }}</b>
                      <v-tooltip v-if="KPI.description" left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" class="pa-1" small>
                            mdi-information
                          </v-icon>
                        </template>
                        <span>{{ KPI.description }}</span>
                      </v-tooltip>
                    </div>
                  </v-col>

                  <v-col cols="6" class="custom-vertical-center">
                    <div>{{ KPI.amount }} {{ KPI.unit }}</div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </td>
      </template>

    </v-data-table>
  </v-card>
</template>

<script>
import UpdateEmployee from '@components/HR/UpdateEmployee.vue';

export default {
  name: 'EmployeeTable',
  props: ['tableData', 'client'],
  components: {
    UpdateEmployee
  },

  data() {
    return {
      headers: [
        { text: '', value: 'data-table-expand' },
        { text: 'Mitarbeiter', value: 'fullname', sort: (user1, user2) => this.compareFullName(user1.firstname, user1.lastname, user2.firstname, user2.lastname) },
        { text: 'Stunden Saldo (h)', value: 'stdSaldo' },
        { text: 'Gleitzeitkonto (h)', value: 'gzk' },
        { text: 'Urlaub (Tage)', value: 'urlaub' },
        { text: 'Monatsabschluss', value: 'status' },
        { text: 'Impersonate', value: 'impersonate', sortable: false }
      ],

      expandedRows: [],
      parsedTableData: undefined,

      KPIs: {
        loading: false,
        values: {}
      }
    }
  },

  mounted() {
    const parsedEmployeeData = [];
    this.tableData.forEach((user) => {
      if (user.userData.masterData?.hiddenFromHrView == true) {
        return;
      }

      parsedEmployeeData.push({
        mocoUserID: user.userData.mocoUserID,
        fullname: {
          firstname: user.userData.firstname,
          lastname: user.userData.lastname,
        },
        
        id: user.userData.mocoUserID,
        email: user.userData.email,
        avatar_url: user.userData.avatar_url,
        isStillEmployed: user.userData.isStillEmployed,
        hasJiraUser: user.jiraUserData?.id != undefined,
        team: user.userData.team,

        stdSaldo: user.monthData.hours.totalDiff,
        gzk: user.monthData.hours.flexTimeBalance,
        urlaub: user.monthData.holiday.atEndOfMonth,
        status: user.monthData.closing.status,

        personnelNumber: user.userData.masterData?.personnelNumber,
        birthday: user.userData.masterData?.birthday,
        address: user.userData.masterData?.address,
        employedSince: user.userData.masterData?.employedSince,
        employedUntil: user.userData.masterData?.employedUntil,
        overTimeFlat: user.userData.masterData?.overTimeFlat,
        monthlyFlexTimeCorrection: user.userData.masterData?.monthlyFlexTimeCorrection
      });
    });

    parsedEmployeeData.sort((a, b) => {
      const sameBucket = (a.status === global.monthClosing.status.open && b.status === global.monthClosing.status.open)
        || (a.status !== global.monthClosing.status.open && b.status !== global.monthClosing.status.open);

      if (sameBucket) {
        return this.compareFullName(a.fullname.firstname, a.fullname.lastname, b.fullname.firstname, b.fullname.lastname)
      } else {
        return a.status === global.monthClosing.status.open ? 1 : -1;
      }
    });

    this.parsedTableData = parsedEmployeeData;
  },

  computed: {
    displayedDate: function () {
      return this.$store.state.displayedMonth;
    },

    userUpdateEnabled: function () {
      return this.$store.getters.staticUserData.user.roles.isHR && this.$route.name == global.ROUTES.hr.employees.name;
    }
  },

  methods: {
    toggleExpand(row) {
      if (this.expandedRows.includes(row)) {
        // wieso includes geht aber indexOf nicht, versteh ich nicht...
        this.expandedRows = this.expandedRows.filter(expandedRow => expandedRow.personnelNumber != row.personnelNumber);
      } else {
        this.expandedRows.push(row);
      }
    },

    impersionationEnabled(user) {
      return /*user.isStillEmployed == true && */ user.hasJiraUser == true
    },

    gotoMonatsabschlussEnabled(user) {
      return user.status != global.monthClosing.status.open;
    },

    getMonatsabschlussRoute(user) {
      return {
        name: global.ROUTES.monatsabschluss.name,
        params: {
          username: user.email.replace('@seqis.com', ''),
          year: this.displayedDate.year(),
          month: this.displayedDate.isoMonth()
        }
      };
    },

    getMonatsabschlussStatusColor(status) {
      switch (status) {
        case global.monthClosing.status.approved:
          return 'green lighten-1';
        case global.monthClosing.status.open:
          return 'black'; // nicht notwendig, button ist disabled!
        case global.monthClosing.status.waitingForTL:
          return 'orange lighten-1';
        case global.monthClosing.status.waitingForHR:
          return 'orange lighten-1';
        case global.monthClosing.status.rejected:
          return 'red lighten-2';
      }
    },

    impersonate(user) {
      return {
        name: global.ROUTES.monatsansicht.name,
        params: {
          year: this.displayedDate.year(),
          month: this.displayedDate.isoMonth()
        },
        query: {
          impersonation: user.id
        }
      };
    },

    async startCalculation(user) {
      this.KPIs.loading = true;
      const KPIs = await this.client.calcUserKPIs(user.id, this.displayedDate.year());
      this.KPIs.loading = false;
      
      this.KPIs.values[user.id] = [];
      // eslint-disable-next-line no-unused-vars
      Object.entries(KPIs).forEach(([key, kpi]) => {
        this.KPIs.values[user.id].push(kpi);
      });
    },

    rowBackground(user) {
      return user.employedUntil ? 'red lighten-2' : '';
    }
  }
}
</script>
<style lang="scss">
tr>td,
tr>td>label {
  cursor: pointer
}

tr>td:last-of-type {
  cursor: default
}

.align-center {
  display: flex;
  align-items: center;
}
.custom-vertical-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
} 
</style>